export const SITE_ORIGIN = 'https://akas.co';

export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/images/akas-logo.png`;

export const SITE_NAME = 'AKAS';
